var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7509 6.31669H13.1009C12.7759 6.31669 12.5176 6.05836 12.5176 5.73336C12.5176 5.40836 12.7759 5.15002 13.1009 5.15002H17.7509C18.0759 5.15002 18.3342 5.40836 18.3342 5.73336C18.3342 6.05836 18.0759 6.31669 17.7509 6.31669Z",
    fill: "#0376C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34935 6.31669H2.24935C1.92435 6.31669 1.66602 6.05836 1.66602 5.73336C1.66602 5.40836 1.92435 5.15002 2.24935 5.15002H5.34935C5.67435 5.15002 5.93268 5.40836 5.93268 5.73336C5.93268 6.05836 5.66602 6.31669 5.34935 6.31669Z",
    fill: "#0376C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44987 9.02498C10.2678 9.02498 11.7415 7.55125 11.7415 5.73332C11.7415 3.91538 10.2678 2.44165 8.44987 2.44165C6.63193 2.44165 5.1582 3.91538 5.1582 5.73332C5.1582 7.55125 6.63193 9.02498 8.44987 9.02498Z",
    fill: "#0376C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7497 14.8417H14.6497C14.3247 14.8417 14.0664 14.5833 14.0664 14.2583C14.0664 13.9333 14.3247 13.675 14.6497 13.675H17.7497C18.0747 13.675 18.3331 13.9333 18.3331 14.2583C18.3331 14.5833 18.0747 14.8417 17.7497 14.8417Z",
    fill: "#0376C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89935 14.8417H2.24935C1.92435 14.8417 1.66602 14.5833 1.66602 14.2583C1.66602 13.9333 1.92435 13.675 2.24935 13.675H6.89935C7.22435 13.675 7.48268 13.9333 7.48268 14.2583C7.48268 14.5833 7.21602 14.8417 6.89935 14.8417Z",
    fill: "#0376C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5495 17.5583C13.3674 17.5583 14.8411 16.0846 14.8411 14.2666C14.8411 12.4487 13.3674 10.975 11.5495 10.975C9.73154 10.975 8.25781 12.4487 8.25781 14.2666C8.25781 16.0846 9.73154 17.5583 11.5495 17.5583Z",
    fill: "#0376C9"
  })));
};
export default SvgFilter;